import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { ROUTES } from '../../assets/constants/strings';
import AccountPagesWrapper from '../../components/Account/PageWrapper';
import Plans from './Plans';
import { isApiOnly, isAuthenticated } from '../../services/entitlements';

// Reader plans page. Reader access is sales-led now (Trial + Enterprise, no
// self-serve pricing) — the old Paddle checkout orchestration is gone; the page
// just renders the two-state Trial/Enterprise view with a Contact Us enquiry.
// NOTE: do NOT gate the render on state.user.loading — the Contact Us enquiry
// toggles that flag, and swapping in a loader here would unmount Plans (and the
// open modal with it) mid-submit, so the success confirmation would never show.
const mapStateToProps = (state) => ({
  user: state.user.user,
});

const PlansPage = ({ user }) => {
  const [isUpdateSubs, setIsUpdateSubs] = useState(false);

  const pathname = window.location.pathname;

  useEffect(() => {
    if (pathname) setIsUpdateSubs(pathname.includes('update-subscription'));
  }, [pathname]);

  if (!isAuthenticated(user)) return <Redirect to={ROUTES.LOGIN} />;
  if (user && isApiOnly(user)) return <Redirect to={ROUTES.APIHOME} />;

  return (
    <AccountPagesWrapper noContainer hideText className='selectPlans'>
      <Plans isUpdate={isUpdateSubs} />
    </AccountPagesWrapper>
  );
};

export default connect(mapStateToProps)(PlansPage);
